export default __webpack_public_path__ + "static/media/check.e0ce40a1.png";